
import React from "react";
import {
  TreePine,
  Home,
  Landmark,
  Warehouse,
} from "lucide-react";
import image from "../../assets/offer.png";

const WhatWeOffer = () => {
  const items = [
    { icon: TreePine, title: "Agricultural Lands" },
    { icon: Warehouse, title: "Plantation Properties" },
    { icon: Home, title: "Residential Plots" },
    { icon: Landmark, title: "Investment Lands" },
  ];

  return (
    <section className="container mx-auto mb-12 px-4">
      <div className="">

        {/* TITLE */}
        <h2 className="text-center text-[28px] md:text-[34px] font-serif text-gray-800 mb-10">
          What We Offer
        </h2>

        {/* ================= ICON SECTION ================= */}

        {/* Desktop */}
        <div className="hidden md:flex bg-[#45A3010D] rounded-2xl py-8 px-10 mb-14 justify-between items-center">
          {items.map((item, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center gap-3 w-[120px]"
            >
              {/* ICON BOX */}
              <div className="w-12 h-12 flex items-center justify-center border border-[#E5E3DD]">
                <item.icon className="text-[#0F172A]" size={22} />
              </div>

              {/* TEXT */}
              <p className="text-[16px] text-[#0F172A] leading-snug">
                {item.title}
              </p>
            </div>
          ))}
        </div>

        {/* Mobile Scroll */}
        <div className="md:hidden flex gap-6 overflow-x-auto bg-[#45A3010D] rounded-2xl px-5 py-5 mb-12">
          {items.map((item, index) => (
            <div
              key={index}
              className="min-w-[110px] flex flex-col items-center text-center gap-3"
            >
              {/* ICON BOX */}
              <div className="w-11 h-11 flex items-center justify-center border border-[#E5E3DD]">
                <item.icon className="text-[#0F172A]" size={20} />
              </div>

              {/* TEXT */}
              <p className="text-xs text-[#0F172A] leading-snug">
                {item.title}
              </p>
            </div>
          ))}
        </div>

        {/* ================= BOTTOM SECTION ================= */}

        <div className="grid md:grid-cols-2 gap-12 items-center px-10">

          {/* IMAGE */}
          <div className="order-1 md:order-2">
            <img
              src={image}
              alt="Plantation"
              className="w-full h-[240px] sm:h-[280px] md:h-[320px] lg:h-[340px] object-cover rounded-xl shadow-md"
            />
          </div>

          {/* CONTENT */}
          <div className="order-2 md:order-1">
            <h3 className="text-[22px] md:text-[30px] font-serif text-[#0F172A] mb-4 leading-snug">
              Dedicated to Excellence in Luxury Land Acquisition
            </h3>

            <p className="text-[#475569] text-[16px] leading-relaxed mb-6 max-w-md">
              For over two decades, KL Property has been at the forefront of the
              luxury real estate market, specializing in high-value land
              investments and residential assets. Our portfolio is curated for
              the discerning investor.
            </p>

            {/* STATS */}
            <div className="flex items-center justify-start gap-10 mt-6">

              {/* LEFT */}
              <div className="flex flex-col">
                <h4 className="text-[#45A301] text-[40px] font-semibold leading-none">
                  30+
                </h4>
                <p className="text-[15px] text-[#64748B] mt-2">
                  Years Exp
                </p>
              </div>

              {/* DIVIDER */}
              <div className="h-14 w-[1px] bg-[#E5E3DD]"></div>

              {/* RIGHT */}
              <div className="flex flex-col">
                <h4 className="text-[#45A301] text-[40px] font-semibold leading-none">
                  500+
                </h4>
                <p className="text-[15px] text-[#64748B] mt-2">
                  Assets
                </p>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default WhatWeOffer;